import React from 'react'
import Button from '@material-ui/core/Button'
import {firestore } from '../../firebase'
import moment from 'moment'
import { dialog } from 'store/actions/dialogActions'
const DeletePlaningData = () => {


    const handleDeletePlaningData = () => {
        const currentYear = moment().format('YYYY')

        const delPlaningData = async () => {
            const currentDate = `${currentYear}-01-01`
    
            const planningREF = firestore.collection('planning')
            .where('start', '<', currentDate)
            const planningSnap = await planningREF.get()
            planningSnap.forEach(async e=>{
                const id = e.id
                const docREF = firestore.collection('planning').doc(id)
            
                docREF.delete()
            })
      
            return dialog('reset')
        }
        
        const deleteButton = {onClick: delPlaningData, title:'Daten löschen', variant:'contained', color:'secondary'}
        const cancelButton = {onClick: ()=>dialog('reset'), title: 'Abbrechen',variant:'contained', color:'primary'}
        return dialog({
            isOpen: true,
            title:'Planungsdaten löschen',
            text:`Wollen Sie alle Planungsdaten vor 01.01.${currentYear} löschen?`,
            buttons: [deleteButton, cancelButton]
        })
    }
  return (
    <div style={{marginTop: '10px'}}>
        <Button onClick={handleDeletePlaningData} color='primary' variant='outlined'>Löschen</Button>
    </div>
  )
}

export default DeletePlaningData
